(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intro-logo"] && !Shopify.designMode) return;
  try {
    
(function(){
  var intro=document.getElementById('intro');
  if(!intro)return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches,seen=false;
  var force=/[?&]intro\b/.test(location.search);
  var FREQ=window.G2_INTRO_FREQ||'session';
  try{
    if(FREQ==='session') seen=sessionStorage.getItem('g2-intro-seen')==='1';
    else if(FREQ==='once') seen=localStorage.getItem('g2-intro-seen')==='1';
    else seen=false;                       // 'always'
  }catch(e){}
  if(force){try{sessionStorage.removeItem('g2-intro-seen')}catch(e){}seen=false}
  if((seen||reduce)&&!force){document.documentElement.classList.add('intro-off');return}
  document.documentElement.classList.add('intro-playing');

  var mark=document.getElementById('introMark'),
      wash=document.getElementById('introWash'),hint=document.getElementById('introHint'),
      scrim=document.getElementById('introScrim'),
      lines=intro.querySelectorAll('.intro-line'),skip=document.getElementById('introSkip'),
      ticking=false, ZOOM=(window.G2_INTRO_ZOOM||10)-1, RISE=16, handedOff=false;
  /* The copy now finishes before the wash starts, so the two are never fighting
     for the same screen. The intro is 250vh rather than 320vh, so every band
     moved earlier with it. */
  var BANDS=[[0,.24],[.28,.58]];
  function markSeen(){try{
    if(FREQ==='session')sessionStorage.setItem('g2-intro-seen','1');
    else if(FREQ==='once')localStorage.setItem('g2-intro-seen','1');
  }catch(e){}}
  function ease(t){return t*t}
  function frame(){
    ticking=false;
    var total=intro.offsetHeight-window.innerHeight;
    if(total<=0)return;
    var p=Math.min(1,Math.max(0,-intro.getBoundingClientRect().top/total));

    /* Decide the hand-off FIRST, and stop painting once it has happened.

       Removing `intro-playing` puts the chrome back in the flow and pushes the
       intro down, which lowers p by about 0.16. That is unavoidable. What must
       not happen is drawing the animation from that lowered number: on the next
       scroll event the wash was recomputed at roughly 0.56 instead of 1, so the
       logo faded back INTO view after it had gone — the animation appearing to
       come back, half there, once it was already finished.

       Two thresholds keep the class from oscillating; holding the end state
       keeps the picture from rewinding. Both are needed, and neither substitutes
       for the other. */
    if(!handedOff && p >= 0.94){
      handedOff = true;
      document.documentElement.classList.remove('intro-playing');
    } else if(handedOff && p <= 0.55){
      handedOff = false;
      document.documentElement.classList.add('intro-playing');
    }
    if(handedOff){ settle(); return; }

    mark.style.transform='scale('+(1+ease(p)*ZOOM).toFixed(4)+')';
    /* Opacity was a bare triangular ramp, which starts and stops at full speed
       and reads as a pop. Smoothstep eases both ends, and the line lifts as it
       arrives and keeps lifting as it leaves, so it moves with the zoom rather
       than blinking on top of it. */
    var peak=0;
    for(var i=0;i<lines.length;i++){
      var b=BANDS[i],o=0,dy=RISE;
      if(b&&p>=b[0]&&p<=b[1]){
        var l=(p-b[0])/(b[1]-b[0]);
        var t=Math.min(1,Math.min(l,1-l)*6);
        o=t*t*(3-2*t);
        dy=(1-o)*RISE*(l<0.5?1:-1);
      }
      if(o>peak)peak=o;
      lines[i].style.opacity=o.toFixed(3);
      lines[i].style.transform='translateY('+dy.toFixed(1)+'px)';
    }
    if(scrim)scrim.style.opacity=peak.toFixed(3);
    /* This snapped the cue off at 4% — roughly one flick of a thumb — so the
       one instruction on the screen was gone before a hesitant visitor had
       read it. It now holds until the animation is a third done, then fades
       over the next tenth, by which point scrolling is self-evidently working. */
    if(hint){var hv=p<=.30?1:Math.max(0,1-(p-.30)/.10);hint.style.opacity=hv.toFixed(3)}
    var w=p>.60?Math.min(1,(p-.60)/.32):0;
    if(wash)wash.style.opacity=w.toFixed(3);
    /* Skip sits above the wash, so without this it stayed on screen as a live
       control floating on a flat colour after the animation had finished. It
       leaves with the picture it was offering to skip. */
    if(skip){skip.style.opacity=(1-w).toFixed(3);skip.style.pointerEvents=w>.9?'none':'auto';}
    /* The stage used to fade to nothing over the last 6%, which revealed the
       section's own background and left you looking at a flat screen that
       belonged to neither the animation nor the page. It stays fully opaque
       now; the wash has already taken it to Gun Black, which is the hero's
       colour, so the intro simply scrolls away into a hero of the same shade.
       Nothing fades, so there is nothing to flicker. */
    if(p>=.995)markSeen();
  }
  /* The finished frame, painted once and then left alone. */
  function settle(){
    mark.style.transform='scale('+(1+ZOOM).toFixed(4)+')';
    for(var i=0;i<lines.length;i++){lines[i].style.opacity='0';}
    if(scrim)scrim.style.opacity='0';
    if(hint)hint.style.opacity='0';
    if(wash)wash.style.opacity='1';
    if(skip){skip.style.opacity='0';skip.style.pointerEvents='none';}
    markSeen();
  }
  function onScroll(){
    if(ticking)return; ticking=true;
    if(typeof requestAnimationFrame==='function'&&!document.hidden){requestAnimationFrame(frame)}
    else{setTimeout(frame,0)}
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  document.addEventListener('visibilitychange',function(){ticking=false;frame()});
  /* This used to remove `intro-playing` and then smooth-scroll to a target
     computed from intro.offsetTop. Two things went wrong with that. Removing
     the class puts the header, utility bar and category nav back into the flow,
     which moves the intro down the page by the height of that stack — measured
     at 171px on desktop — so the target was short by exactly that much. And it
     never added `intro-off`, so the 320vh black block stayed on the page: you
     pressed Skip, the header appeared, and you were still looking at the
     animation. Skip now removes the block outright and lands on the content.
     No smooth scroll — a control called Skip should be instant, and a two
     thousand pixel glide is the thing the user just asked to be spared. */
  if(skip)skip.addEventListener('click',function(){
    markSeen();
    var html=document.documentElement;
    html.classList.remove('intro-playing');
    html.classList.add('intro-off');
    window.scrollTo({top:0,left:0,behavior:'auto'});
  });
  frame();
})();

  } catch(e) { console.error(e); }
})();
})();
